var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownBurgundy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.52,
    height: 15,
    viewBox: "0 0 23.52 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow_Left",
    "data-name": "Arrow Left",
    d: "M2.5,23.52a2.57,2.57,0,0,0,1.768-.689l10-9.408a2.254,2.254,0,0,0,0-3.326L4.267.689a2.612,2.612,0,0,0-3.535,0,2.254,2.254,0,0,0,0,3.326L8.964,11.76.732,19.505a2.254,2.254,0,0,0,0,3.326A2.57,2.57,0,0,0,2.5,23.52",
    transform: "translate(23.52) rotate(90)",
    fill: "#991F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBurgundy);
export default __webpack_public_path__ + "static/media/ArrowDownBurgundy.5a75b0baf69f24dbefd0866b4676f2dc.svg";
export { ForwardRef as ReactComponent };